import { render, staticRenderFns } from "./TabButtons.vue?vue&type=template&id=07fc41ef&scoped=true&"
import script from "./TabButtons.vue?vue&type=script&lang=js&"
export * from "./TabButtons.vue?vue&type=script&lang=js&"
import style0 from "./TabButtons.vue?vue&type=style&index=0&id=07fc41ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc41ef",
  null
  
)

export default component.exports